/* eslint-disable */
import profile from "../images/profile.jpeg"; 
import BrandLogo from "../images/brand-logo.svg"; 
const Images = {
  profile,
  BrandLogo 
};
export default Images;
